// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__2CiaN"};